import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import kualifikasiService from "../../../services/ref/kualifikasiService";
import Cookies from "js-cookie";

export const initialState = {
    loading_kualifikasi: false,
    data_kualifikasi: [],
    showMessage:false,
    message:'',
}


export const getDataKualifikasi = createAsyncThunk('kualifikasi/data',async (data, { rejectWithValue }) => {
    try {
        const response = await kualifikasiService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const kualifikasiSlice = createSlice({
    name: 'kualifikasi',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_kualifikasi = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataKualifikasi.fulfilled, (state, action) => {
                state.loading_kualifikasi = false
                state.data_kualifikasi = action.payload??[]
            })
            .addCase(getDataKualifikasi.pending, (state) => {
                state.loading_kualifikasi = true
            })
            .addCase(getDataKualifikasi.rejected, (state, action) => {
                state.loading_kualifikasi = false
                state.data_kualifikasi = action.payload
            })
    },
})

export const {
    showLoading,
} = kualifikasiSlice.actions

export default kualifikasiSlice.reducer
